import { CodeCommand } from "commands/CodeCommand";
import { IdCommand } from "commands/IdCommand";
import { AddPlayerToWatchListCommand } from "commands/frankenstories/AddPlayerToWatchListCommand";
import { AddWatchWordCommand } from "commands/frankenstories/AddWatchWordCommand";
import { BanPlayerCommand } from "commands/frankenstories/BanPlayerCommand";
import { EditTeamCommand } from "commands/frankenstories/EditTeamCommand";
import { GameIdCommand } from "commands/frankenstories/GameIdCommand";
import { GameRoundCommand } from "commands/frankenstories/GameRoundCommand";
import { GameVotingRoundCommand } from "commands/frankenstories/GameVotingRoundCommand";
import { RejectReplyCommand } from "commands/frankenstories/RejectReplyCommand";
import { SplitGameCommand } from "commands/frankenstories/SplitGameCommand";
import { SpotlightReplyCommand } from "commands/frankenstories/SpotlightReplyCommand";
import { ToggleApprovalModeCommand } from "commands/frankenstories/ToggleApprovalModeCommand";
import { RenameGameCommand } from "commands/frankenstories/RenameGameCommand";
import { RenameTeamCommand } from "commands/frankenstories/RenameTeamCommand";
import { UpdateGameRulesSettingsCommand } from "commands/frankenstories/UpdateGameRulesSettingsCommand";
import { UpdateWatchListMinimumWordCountCommand } from "commands/frankenstories/UpdateWatchListMinimumWordCountCommand";
import { GameQuery } from "queries/frankenstories/GameQuery";
import { GetEditTeamResult } from "results/frankenstories/GetEditTeamResult";
import { GetModerateResult } from "results/frankenstories/GetModerateResult";
import { GetPopularWatchWordsResult } from "results/frankenstories/GetPopularWatchWordsResult";
import { GetReplyReactionsResult } from "results/frankenstories/GetReplyReactionsResult";
import { GetReplyVotersResult } from "results/frankenstories/GetReplyVotersResult";
import { useApiService } from "services/ApiService";

export const ModerateApiService = () => {
    const { get, post } = useApiService({ controller: "/moderate" });

    return {
        rejectReply: (command: RejectReplyCommand) => post("/reject-reply", command),
        allowReply: (command: RejectReplyCommand) => post("/allow-reply", command),
        approveRound: (command: GameRoundCommand) => post("/approve-round", command),
        endWriting: (command: GameRoundCommand) => post("/end-writing", command),
        endVoting: (command: GameVotingRoundCommand) => post("/end-voting", command),
        endAwarding: (command: GameRoundCommand) => post("/end-awarding", command),
        endReporting: (command: CodeCommand) => post("/end-reporting", command),
        getModerate: (code: string) => get<GetModerateResult>(`/moderate/${code}`),
        updateRules: (command: UpdateGameRulesSettingsCommand) => post("/update-rules", command),
        banPlayer: (command: BanPlayerCommand) => post("/ban-player", command),
        unbanPlayer: (command: BanPlayerCommand) => post("/unban-player", command),
        getPopularWatchWords: (country: string) => get<GetPopularWatchWordsResult>(`/popular-watch-words/${country}`),
        pauseGame: (command: CodeCommand) => post("/pause-game", command),
        resumeGame: (command: CodeCommand) => post("/resume-game", command),
        awardSticker: (command: IdCommand) => post("/award-sticker", command),
        removeSticker: (command: IdCommand) => post("/remove-sticker", command),
        addPlayerToWatchList: (command: AddPlayerToWatchListCommand) => post("/add-player-to-watch-list", command),
        removePlayerFromWatchList: (command: IdCommand) => post("/remove-player-from-watch-list", command),
        addWatchWord: (command: AddWatchWordCommand) => post("/add-watch-word", command),
        removeWatchWord: (command: IdCommand) => post("/remove-watch-word", command),
        renameGame: (command: RenameGameCommand) => post("/rename-game", command),
        renameTeam: (command: RenameTeamCommand) => post("/rename-team", command),
        getEditTeam: (id: number) => get<GetEditTeamResult>(`/edit-team/${id}`),
        editTeam: (command: EditTeamCommand) => post("/edit-team", command),
        getReplyVoters: (code: string, id: number) => get<GetReplyVotersResult>(`/reply-voters/${code}/${id}`),
        getReplyReactions: (code: string, id: number) => get<GetReplyReactionsResult>(`/reply-reactions/${code}/${id}`),
        regeneratePlayerName: (command: GameIdCommand) => post("/regenerate-player-name", command),
        updateWatchListMinimumWordCount: (command: UpdateWatchListMinimumWordCountCommand) =>
            post("/update-watch-list-minimum-word-count", command),
        splitGame: (command: SplitGameCommand) => post("/split-game", command),
        toggleApprovalMode: (command: ToggleApprovalModeCommand) => post("/toggle-approval-mode", command),
        analyseGame: (command: CodeCommand) => post("/analyse-game", command),
        spotlightReply: (command: SpotlightReplyCommand) => post("/spotlight-reply", command),
        clearSpotlightReply: (command: GameQuery) => post("/clear-spotlight-reply", command),
    };
};
